import { message } from 'antd'
import React from 'react'

const myMessage = {
  success: (content) => {
    message.success({
      duration: 3,
      content: content,
      icon: <span className="iconfont icon_success"></span>,
      className: 'message-success',
    })
  },
  warning: (content) => {
    message.warning({
      duration: 3,
      content: content,
      icon: <span className="iconfont icon_warning"></span>,
      className: 'message-warning',
    })
  },
  error: (content) => {
    message.error({
      duration: 3,
      content: content,
      icon: <span className="iconfont icon_error"></span>,
      className: 'message-error',
    })
  },
}
export default myMessage
